/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { gql, useQuery } from '@apollo/client';

export const useGetDisplayIndicativePrice = () => {

    const variables = {
        "request": {
     "partNumber": ["TD_SecureStorage_Platinum",
    "TD_SecureStorage_Silver",
    "TD_SecureStorage_Gold"],
    "priceRuleName": "MetalsSellIndicativePriceRule",
    "type": "byPartNumbersAndPriceRuleName"
  }
    }

    const INDICATIVE_PRICE_GQL = gql`
    query GetDisplayIndicativePrice($request: IndicativePriceInput!) {
    getDisplayIndicativePrice(request: $request) {
    resourceId
    resourceName
    resultList {
      catalogEntryId
      partNumber
      priceRuleId
      priceRuleName
      unitPrice {
        price {
          currency
          value
        }
        quantity {
          uom
          value
        }
      }
    }
  }
}
`

const { data, loading, error } = useQuery(INDICATIVE_PRICE_GQL, {
    variables,
    fetchPolicy:"network-only",
    context:{
      clientName:"/price"
    }
  });

  return { data, loading, error };
}